import { useEffect, useRef, useState } from "react";
import { AddTicketsInput } from "./AddTickets";
import { ADD_TICKETS_BY_ADMIN, GET_EVENT_BY_IDs } from "./api/addTicketsQuery";
import { useLazyQuery, useMutation } from "@apollo/client";
import { checking, CustomPaperComponent, splitLocation } from "../../helper";
import eventStyles from "../../components/shared-components/mark-as-sold/MarkAsSold.module.css";
import addTicketStyles from "./AddTickets.module.css";
import { Button, CircularProgress, Dialog } from "@mui/material";
import { useFieldArray, useForm } from "react-hook-form";
import ToasterWithMessage from "../../components/shared-components/toaster";
import stylesUser from "../Users/Users.module.css";
import PublishPopup from "../../components/shared-components/success-popup/PublishPopup";
import TicketsList from "./TicketsList";

interface Event {
    e_id: string;
    e_date: string;
    e_address: string;
    e_name: string;
}

type Seat = {
    section: string;
    row: string;
    seatNo: { value: string }[]; 
  };
  
type Ticket = {
    eventId: string;
    eventName: string;
    eventDate: string;
    eventAddress: string;
    tickets: Seat[];
};
  
type FormData = {
    ticketDetails: Ticket[];
};

const StyledComponent = CustomPaperComponent();
const AddTicketDetailsForm = ({
    setPage,
    ticketDetails,
    setTicketDetails
}: AddTicketsInput) => {
    const [eventList, setEventList] = useState<Event[]>([]);
    const [currentEventIndex, setCurrentEventIndex] = useState(0);
    const isCopyProceedPopupShown = useRef(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogForAutofill, setOpenDialogForAutofill] = useState(false);
    const [submitData, setSubmitData] = useState<FormData>();
    const { success, error } = ToasterWithMessage();

    const { control, handleSubmit, getValues, setValue, formState: { errors }, watch, trigger } = useForm<FormData>({
        defaultValues: {
          ticketDetails: []
        }
    });
    
    const { fields: eventFields, append } = useFieldArray({
        control,
        name: "ticketDetails"
    });

    const [getEventById, { loading }] = useLazyQuery(GET_EVENT_BY_IDs, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setEventList(data?.events);
            data.events.forEach((event: Event) => append({
                eventId: event.e_id,
                eventName: event.e_name,
                eventDate: event.e_date,
                eventAddress: event.e_address,
                tickets: [
                    {
                        section: "",
                        row: "",
                        seatNo: [{value: ""}]
                    }
                ]
            }));
        },
        onError: (err) => {
            console.log(err.message, "===error")
        }
    });

    const [addTicketsByAdmin, { loading: addTicketsLoading }] = useMutation(ADD_TICKETS_BY_ADMIN, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            success(data?.addTicketsByAdmin?.message);
            setPage(0);
            setTicketDetails(null);
        },
        onError: (err) => {
            console.log(err.message, "===error")
            error(err?.message);
        }
    });

    useEffect(() => {
        getEventById({
            variables: {
                eventId: ticketDetails?.eventId
            }
        })
    }, []);

    // const handleKeyDown = (e :any) =>{
    //     if(e.key === 'Backspace'){
    //       setTickets([
    //         {
    //             section: "",
    //             row: "",
    //             seatNo: [""]
    //         }
    //       ])
    //     }
    //   }

    const onSubmit = async (data: FormData) => {
        setSubmitData(data);
        if(currentEventIndex === eventList.length - 1) {
            setOpenDialog(true)
        } else if(currentEventIndex === 0){
            if(isCopyProceedPopupShown.current) {
                setCurrentEventIndex((prev) => {
                    return prev + 1;
                });
            } else {
                setOpenDialogForAutofill(true)
            }
        } else {
            setCurrentEventIndex((prev) => {
                return prev + 1;
            });
        }
    }

    const handleCancel = () => {
        if(currentEventIndex === 0) {
            setTicketDetails(null);
            setPage(0);
        } else {
            setCurrentEventIndex((prev) => prev - 1)
        }
    }
    const handleAllowDialog = async () => {
        setOpenDialog(false);
        if(submitData){
            const modifiedTicketData = {
                ticketDetails: submitData.ticketDetails.map(event => ({
                    eventId: event.eventId,
                    tickets: event.tickets.map(ticket => ({
                        ...ticket,
                        seatNo: ticket.seatNo.map(seat => seat.value)
                    }))
                }))
            };
        await addTicketsByAdmin({
            variables: {
                addTicketsByAdmin: {
                    userId: ticketDetails?.userId,
                    isBulkList: ticketDetails?.isBulkList ?? false,
                    ticketDetails: modifiedTicketData.ticketDetails
                }
            }
        })
        }
    }
    const handleAllowDialogForAutofill = async () => {
        setOpenDialogForAutofill(false);
        setCurrentEventIndex((prev) => prev + 1)
        isCopyProceedPopupShown.current = true
        const currentTickets = getValues(`ticketDetails.${currentEventIndex}.tickets`);
        eventList.forEach((_event, index) => {
            setValue(`ticketDetails.${index}.tickets`, currentTickets);
        });
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    }

    const handleCloseDialogForAutofill = () => {
        isCopyProceedPopupShown.current = true
        setCurrentEventIndex((prev) => {
            return prev + 1;
        });
        setOpenDialogForAutofill(false);
    }

    return (
        <>
            {
                (loading || addTicketsLoading) ? <div className={stylesUser.TableCircularProgress}>
                    <CircularProgress color="primary" size={35} />
                </div> :
                     <div className={addTicketStyles.mainDiv}>
                       <form onSubmit={handleSubmit(onSubmit)}>

                        {eventFields.length > 0 && (
                                    <>
                                    <div className={eventStyles.event}>
                                                    <b className={eventStyles.date}>Event</b>
                                                    <b className={eventStyles.rocketsVsMemphis}>{eventFields[currentEventIndex]?.eventName}</b>
                                                </div>
                                                <div className={eventStyles.event}>
                                                    <b className={eventStyles.date}>Date</b>
                                                    <b className={eventStyles.rocketsVsMemphis}>
                                                        {eventFields[currentEventIndex]?.eventDate ? checking(eventFields[currentEventIndex]?.eventDate).date : ''} /&nbsp;
                                                        {eventFields[currentEventIndex]?.eventDate ? checking(eventFields[currentEventIndex]?.eventDate).time : ''}
                                                    </b>
                                                </div>
                                                <div className={eventStyles.event}>
                                                    <b className={eventStyles.date}>Venue</b>
                                                    <b className={eventStyles.rocketsVsMemphis}>
                                                        {eventFields[currentEventIndex]?.eventAddress ? splitLocation(eventFields[currentEventIndex]?.eventAddress).firstWord : ''}
                                                        {eventFields[currentEventIndex]?.eventAddress ? splitLocation(eventFields[currentEventIndex]?.eventAddress).remainingWords : ''}
                                                    </b>
                                                </div>
                                <div>
                                    <TicketsList control={control} eventIndex={currentEventIndex} errors = {errors} watch = {watch} setValue = {setValue} trigger = {trigger} />
                                </div>
                                    
                                    
                                    </>
                            )}

                        <div className={addTicketStyles.buttonDiv}>
                             <div className={addTicketStyles.updateButtonStyle}>
                                 <Button
                                     classes={{
                                         root: addTicketStyles.ticketBtn
                                     }}
                                     disableRipple
                                     fullWidth
                                     type="button"
                                     onClick={handleCancel}
                                 >
                                    {
                                       (currentEventIndex === 0) ? "Cancel" : "Back"
                                    }
                                 </Button>
                             </div>
                             <div className={addTicketStyles.updateButtonStyle}>
                             {currentEventIndex === eventList?.length - 1 ? 
                              <Button
                              classes={{
                                  root: addTicketStyles.ticketBtn
                              }}
                              disableRipple
                              fullWidth
                              type="submit"
                          >
                              Transfer
                          </Button>  : 
                          <Button
                                     classes={{
                                         root: addTicketStyles.ticketBtn
                                     }}
                                     disableRipple
                                     fullWidth
                                     type="submit"
                                 >
                                     
                                        Confirm
                                     
                                 </Button>
                                }
                             </div>
                         </div>
                    </form>
                 </div>
            }
            <Dialog
                open={openDialog}
                PaperComponent={StyledComponent}
            >
                <PublishPopup title="Add Ticket?" subTitle="Are you sure, Do you want to add the tickets?" handleAllow={handleAllowDialog} handleClose={handleCloseDialog} />
            </Dialog>

            <Dialog
                open={openDialogForAutofill && !isCopyProceedPopupShown.current}
                PaperComponent={StyledComponent}
            >
                <PublishPopup title="Copy and Proceed?" subTitle="Are you sure, Do you want to autofill details for all the events?" handleAllow={handleAllowDialogForAutofill} handleClose={handleCloseDialogForAutofill} />
            </Dialog>
        </>
    )
}

export default AddTicketDetailsForm;
